<mat-form-field *ngFor="let dict of dictItems" class="dict-tag">
    <mat-label>{{ dict.name }}</mat-label>
    <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
      <mat-option *ngIf="noneEntry" value="isNull">
        Brak
      </mat-option>

      <mat-option *ngFor="let item of getItems(dict.key)" [value]="item.id">
        {{item.name}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
